import { parseInlineFormatting } from './inlineFormattingHelpers';

const HEADER_REGEX = /^(#{1,6})\s/;
const HEADER_MATCH_REGEX = /^(#{1,6})\s+(.*)/;
const BASE_FONT_SIZE = 13;

export function isHeader(line: string): boolean {
    return HEADER_REGEX.test(line);
}

export function parseHeader(line: string): any[] | null {
    const headerMatch = line.match(HEADER_MATCH_REGEX);
    if (headerMatch) {
        const headerLevel = headerMatch[1].length;
        const headerText = headerMatch[2];
        const fontSize = BASE_FONT_SIZE - headerLevel;

        const formattedElements = parseInlineFormatting(headerText, fontSize);
        return formattedElements;
    }
    return null;
}
